import { render, staticRenderFns } from "./input-array.vue?vue&type=template&id=1a7400d6&lang=pug"
import script from "./input-array.vue?vue&type=script&lang=js"
export * from "./input-array.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports